export const SUPPORTED_GRADES = [
  { title: '2nd Grade', value: 2 },
  { title: '3rd Grade', value: 3 },
  { title: '4th Grade', value: 4 },
  { title: '5th Grade', value: 5 },
  { title: '6th Grade', value: 6 },
  { title: '7th Grade', value: 7 },
];
